/* 新旧业务名称之间的转换 旧=>新 */

export const operationNameConverter = {
  行内转账: '同行汇款',
  跨行转账: '跨行汇款',
  电子账户开立: '新币种账户申请',
  我的收款信息: '收款路径查询',
  收款申报: '汇入汇款申报',
  转账记录查询: '汇款记录查询',
  收款人名册维护: '收款人名册',
  付款申报查询: '汇款申报查询'
}
